export default "__VITE_ASSET__DC9i18sJ__";